<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>
<div class="container-header"><div class="container-header-inner">
  @if (isLoading) { <app-loading-box></app-loading-box> }
  @else if (documento) { <app-nfe-detalhe-emitido [notaDetalhe]="documento" nomeModeloDocumento="NFC-e"></app-nfe-detalhe-emitido> }
  @else { <h1 class="title-default">NFC-e emitida não encontrada</h1> }
</div></div>
